module.exports = __webpack_public_path__ + "img/feedback9-1.5a54400e.jpg";